module.exports = __webpack_public_path__ + "img/done.4d07a2d8.svg";